interface ProductRowsConfig {
  productCount: number;
  contentRowCount: number;
  productsPerRow: number;
}

function pseudoRandom(val: number) {
  const x = Math.sin(val) * 10000;
  return x - Math.floor(x);
}

/**
 * Generate the order of content and product rows on the story page
 * Goals
 * * some kind of randomness for the amount of product rows between content rows
 * * a content row at least in the third row
 * * not more than 4 product rows in a row (in case content rows are left)
 */
const getStoryRowOrder = ({
  productCount,
  contentRowCount,
  productsPerRow,
}: ProductRowsConfig) => {
  const productRowCount = Math.ceil(productCount / productsPerRow);
  const rowCount = productRowCount + contentRowCount;
  const contentRowsDominating = contentRowCount >= productRowCount;

  let remainingContentRows = contentRowCount;
  let remainingProductRows = productRowCount;
  let consecutiveProductRows = 0;
  const createProductRow = (index: number) => {
    remainingProductRows--;
    consecutiveProductRows++;
    return {type: 'product', index} as const;
  };
  const createContentRow = (index: number) => {
    remainingContentRows--;
    consecutiveProductRows = 0;
    return {type: 'content', index} as const;
  };

  return Array(rowCount)
    .fill(null)
    .map((_, index) => {
      if (remainingContentRows === 0) {
        return createProductRow(index);
      }

      if (remainingProductRows === 0) {
        return createContentRow(index);
      }

      if (consecutiveProductRows >= 5) {
        return createContentRow(index);
      }

      if (index === 2 && consecutiveProductRows === 2) {
        return createContentRow(index);
      }

      if (contentRowsDominating) {
        return index % 2 === 0
          ? createProductRow(index)
          : createContentRow(index);
      }

      if (pseudoRandom(rowCount + index) < 0.5 && consecutiveProductRows > 0) {
        return createContentRow(index);
      }

      return createProductRow(index);
    });
};

export {getStoryRowOrder};
